<template>
  <v-row class="d-flex" dense justify="end">
    <template v-for="(object, i) in syntaxFormatters" >
      <v-tooltip bottom :key="i">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              @click="insertSyntax(i)"
              v-shortkey="object.keyboardShortcut"
              @shortkey="insertSyntax(i)"
              icon
              small
              v-bind="attrs"
              v-on="on"
          >
            <v-icon dark>
              {{ object.icon() }}
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(object.label) }}</span>
      </v-tooltip>
    </template>
  </v-row>
</template>

<script>
import Vue from "vue"
Vue.use(require('vue-shortkey'))
import {markdownSyntaxFormatters, getNewTextAreaValueWithEdits} from "../extensions/markdownSyntaxFormatting";

export default {
  name: "MarkdownToolbar",
  props: ['textAreaId'],
  data() {
    return {
      textAreaRef: {
        current: null
      },
      syntaxFormatters: {}
    }
  },
  methods: {
    insertSyntax(syntaxName) {
      const {current: textArea} = this.textAreaRef;
      const {
        newCursorStart,
        newCursorEnd,
        editSelectionStart,
        editSelectionEnd,
        replaceSelectionWith,
      } = markdownSyntaxFormatters[syntaxName].getFormatting(textArea);

      textArea.contentEditable = 'true';
      textArea.focus({preventScroll: true});
      textArea.setSelectionRange(editSelectionStart, editSelectionEnd);

      try {
        if (replaceSelectionWith === '') {
          document.execCommand('delete', false);
        } else {
          document.execCommand('insertText', false, replaceSelectionWith);
        }
      } catch {
        textArea.value = getNewTextAreaValueWithEdits({
          textAreaValue: textArea.value,
          editSelectionStart,
          editSelectionEnd,
          replaceSelectionWith,
        });
      }


      textArea.contentEditable = 'false';
      textArea.dispatchEvent(new Event('input'));
      textArea.setSelectionRange(newCursorStart, newCursorEnd);


    },

    loadSyntaxFormatters() {
      this.syntaxFormatters = Object.fromEntries(
          Object.entries(markdownSyntaxFormatters)
      )
    }
  },

  mounted() {
    this.textAreaRef.current = document.getElementById(this.textAreaId);
    this.loadSyntaxFormatters();
  }
}
</script>

<i18n lang="i18n">
{
  "en": {
    "insertTable": "Insert table",
    "deleteTable": "Delete table",
    "addColumnBefore": "Add column before",
    "addColumnAfter": "Add column after",
    "deleteColumn": "Delete column",
    "addRowBefore": "Add row before",
    "addRowAfter": "Add row after",
    "deleteRow": "Delete row",
    "bold": "Bold",
    "italic": "Italic",
    "strike": "Strike",
    "bulletList": "Bullet List",
    "orderedList": "Ordered List",
    "taskList": "Task List",
    "code": "Code"
  },
  "pl": {
    "insertTable": "Wstaw tabele",
    "deleteTable": "Usuń tabele",
    "addColumnBefore": "Wstaw kolumnę przed",
    "addColumnAfter": "Wstaw kolumne po",
    "deleteColumn": "Usuń kolumne",
    "addRowBefore": "Wstaw wiersz przed",
    "addRowAfter": "Wstaw wiersz po",
    "deleteRow": "Usuń wiersz",
    "bold": "Pogrubienie",
    "italic": "Kursywa",
    "strike": "Przekreślenie",
    "bulletList": "Lista punktowana",
    "orderedList": "Lista numerowana",
    "taskList": "Lista zadań",
    "code": "Fragment kodu"
  }
}
</i18n>

